import React, { useEffect, useState } from "react";
import "./Faq.css";
import { Accordion } from "react-bootstrap";
import { FaqCategoryData } from "../../utils/apis/MediaSpace/MediaSpace";
import parse from "html-react-parser";

const Faq = () => {
  const faqData = [
    {
      id: "0",
      question: "1. How can I get a quote for my trip?",
      answer: (
        <>
          <p className="faq_text">
            You can create your own customized trip and get price quoted
            instantly online on this website:
          </p>

          <p className="faq_text">
            all tours and trips can be booked via the booking form. When you
            select a tour or a one-way trip, you will get all the information
            about the itinerary, price, map... price depends on the car category
            (luxury, premium, comfort, economy). You can choose the category
            which suits your needs and budget.
          </p>

          <p className="faq_text">
            for more details about each tour, read the tour descriptions. Use
            the interactive Ladakh tourist map to learn more about the top
            attractions which you could include in your sightseeing tour.
          </p>

          <p className="faq_text">
            the Leh-Ladakh tour packages will give you some ideas on how several
            tours can be combined.
          </p>
        </>
      ),
    },
    {
      id: "1",
      question: "2. Can I book a taxi when I reach Leh?",
      answer:
        "Yes, taxis can be booked after reaching Leh, but advance booking is recommended for availability.",
    },
    {
      id: "2",
      question: "3. Do the drivers speak English?",
      answer: "Yes, most drivers speak basic English and Hindi.",
    },
    {
      id: "3",
      question: "4. Will the driver be flexible during the tour?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
    {
      id: "4",
      question: "5. Will the same driver be with me during the whole trip?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
    {
      id: "5",
      question: "6. I want to be picked up from my hotel in Leh, is it possible?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
    {
      id: "6",
      question: "7. Can you arrange the Inner Line Permit for me?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
    {
      id: "7",
      question: "8. Do you provide an oxygen cylinder for altitude sickness?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
    {
      id: "8",
      question: "9. During the tour, I want to go and see a place which is not included in the itinerary, can this be arranged?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
    {
      id: "9",
      question: "10. Can I rent a self drive car in Ladakh?",
      answer:
        "Yes, drivers are flexible within the planned itinerary and travel guidelines.",
    },
  ];



  const [faqs, setFaqs] = useState();
  const getFaqsDetails = async () => {
    const res = await FaqCategoryData();

    if (res?.success) {
      setFaqs(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  useEffect(() => {
    getFaqsDetails()
  }, []);
  return (
    <section className="Faq">
      <div className="container">
        <h5 className="faq_title">Frequently Asked Questions</h5>

        <div className="faq_section">
          <Accordion defaultActiveKey="0">

            {faqs?.map((faq, index) => (
              <Accordion.Item
                eventKey={faq.id}
                key={faq.id}
                className="faq_item"
              >

                <Accordion.Header className="faq_header">
                  {index + 1}. {faq.name}
                </Accordion.Header>

                <Accordion.Body className="faq_body">
                  {parse(faq.description || "")}
                </Accordion.Body>

              </Accordion.Item>
            ))}

          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Faq;
